import React from 'react'
import card from "../img/card2.png";
import develop from "../img/development.png";
import bug from "../img/bug.png";
import design from "../img/design.png";
import data from "../img/data.png";
import ana from "../img/ana.png";
import cardDark from '../img/cardDark.png';
import developDark from '../img/developmentDark.png';
import designDark from '../img/designDark.png';
import anaDark from '../img/anaDark.png';
import dataDark from '../img/dataDark.png';


const Services = (props) => {
  return (
    <>
      <div id={props.services}>
  <div className="container mx-auto lg:py-16 md:py-16 py-0">
    {/* top */}

    <div className="flex flex-col gap-5 items-center">
    <h1 className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-bold`}>Services</h1>
    <h2 className={`text-3xl font-semibold text-center ${props.darkMode?'text-white':'text-black'}`}>What do I offer?</h2>
    <p className="w-full md:w-2/3 text-center text-gray-400">
      Experienced developer and designer dedicated to creating engaging digital experiences. 
      I specialize in responsive web design and user-friendly interfaces, ensuring functionality meets aesthetics. 
      My passion lies in merging creativity with technology to deliver innovative solutions that elevate brands.
    </p>
  </div>

    {/* bottom */}
    <div className="p-5 flex flex-wrap justify-center lg:gap-5 md:gap-5 gap-14" >
      {/* cards */}

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={props.darkMode?cardDark:card} alt="ui/ux"/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>UI / UX Design</h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>Designing user-friendly interfaces and developing responsive websites.</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={props.darkMode?developDark:develop} alt="Web Development"/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>Web Development</h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>Web development is the process of building, designing, and maintaining websites</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={props.darkMode?designDark:design} alt="ui/ux"/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>Web Design</h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>Frontend developers work on the visual and interactive elements of a website—the parts that users see and interact with directly.</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={bug} alt="Bug Fixing "/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>Bug Fixing </h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>Problems with layout, design, or user interaction.</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={props.darkMode?dataDark:data} alt="ui/ux"/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>UI / UX Design</h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>A data structure is a way of organizing, managing, and storing data so it can be used efficiently.</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      {/* card1 */}
      <div className={`${props.darkMode?'bg-neutral-900':'bg-white'} w-full md:w-4/12 lg:w-3/12 shadow-xl rounded-lg p-5 flex flex-col gap-3 transition-transform transform hover:scale-105`}>
        <img className="w-10" src={props.darkMode?anaDark:ana} alt="ui/ux"/>
        <h1 className={`${props.darkMode?'text-white':'text-black'} font-medium text-lg`}>Version Control</h1>
        <p className={`${props.darkMode?'text-gray-300':'text-gray-400'}`}>Version control is a system that helps track changes made to code, documents, or any digital content over time.</p>
        <a className={`${props.darkMode?'text-orange-500':'text-purple-800'} font-semibold text-sm`} href="/">Read More</a>

      </div>

      

    </div>
  </div>

 </div>

    </>
  )
}

export default Services
